export const sportsCategories = [
  { id: "all", name: "전체", icon: "ri-apps-line" },
  { id: "soccer", name: "해외축구", icon: "ri-football-line" },
  { id: "k-soccer", name: "국내축구", icon: "ri-football-line" },
  { id: "baseball", name: "야구", icon: "ri-award-line" },
  { id: "basketball", name: "농구", icon: "ri-basketball-line" },
  { id: "volleyball", name: "배구", icon: "ri-star-line" },
  { id: "esports", name: "e스포츠", icon: "ri-gamepad-line" },
];

export interface MatchData {
  id: string;
  time: string;
  home: string;
  away: string;
  homeScore?: number;
  awayScore?: number;
  league: string;
  category: string;
  status: "live" | "upcoming" | "finished";
  minute?: string;
  channel: string;
  isHot?: boolean;
}

export const todayMatches: MatchData[] = [
  {
    id: "m1",
    time: "14:00",
    home: "첼시",
    away: "아스널",
    homeScore: 2,
    awayScore: 1,
    league: "프리미어리그",
    category: "soccer",
    status: "live",
    minute: "67'",
    channel: "스포츠중계 1",
    isHot: true,
  },
  {
    id: "m2",
    time: "16:30",
    home: "바이에른 뮌헨",
    away: "도르트문트",
    homeScore: 0,
    awayScore: 0,
    league: "분데스리가",
    category: "soccer",
    status: "live",
    minute: "12'",
    channel: "스포츠중계 2",
    isHot: true,
  },
  {
    id: "m3",
    time: "19:00",
    home: "삼성",
    away: "LG",
    homeScore: 3,
    awayScore: 5,
    league: "KBO",
    category: "baseball",
    status: "live",
    minute: "8회초",
    channel: "스포츠중계 3",
  },
  {
    id: "m4",
    time: "19:30",
    home: "울산",
    away: "전북",
    league: "K리그1",
    category: "k-soccer",
    status: "upcoming",
    channel: "스포츠중계 4",
    isHot: true,
  },
  {
    id: "m5",
    time: "20:00",
    home: "토트넘",
    away: "리버풀",
    league: "프리미어리그",
    category: "soccer",
    status: "upcoming",
    channel: "스포츠중계 1",
    isHot: true,
  },
  {
    id: "m6",
    time: "21:00",
    home: "인터 밀란",
    away: "유벤투스",
    league: "세리에A",
    category: "soccer",
    status: "upcoming",
    channel: "스포츠중계 2",
  },
  {
    id: "m7",
    time: "22:30",
    home: "레알 마드리드",
    away: "바르셀로나",
    league: "라리가",
    category: "soccer",
    status: "upcoming",
    channel: "스포츠중계 1",
    isHot: true,
  },
  {
    id: "m8",
    time: "01:00",
    home: "보스턴",
    away: "뉴욕 양키스",
    league: "MLB",
    category: "baseball",
    status: "upcoming",
    channel: "스포츠중계 3",
  },
  {
    id: "m9",
    time: "02:30",
    home: "골든스테이트",
    away: "LA 레이커스",
    league: "NBA",
    category: "basketball",
    status: "upcoming",
    channel: "스포츠중계 5",
    isHot: true,
  },
  {
    id: "m10",
    time: "03:00",
    home: "디트로이트",
    away: "필라델피아",
    league: "NBA",
    category: "basketball",
    status: "upcoming",
    channel: "스포츠중계 5",
  },
  {
    id: "m11",
    time: "18:00",
    home: "T1",
    away: "Gen.G",
    homeScore: 1,
    awayScore: 2,
    league: "LCK",
    category: "esports",
    status: "live",
    minute: "3세트",
    channel: "e스포츠중계",
    isHot: true,
  },
  {
    id: "m12",
    time: "19:00",
    home: "대한항공",
    away: "현대캐피탈",
    league: "V리그",
    category: "volleyball",
    status: "upcoming",
    channel: "스포츠중계 6",
  },
];

export const tomorrowMatches: MatchData[] = [
  {
    id: "t1",
    time: "15:00",
    home: "맨체스터 시티",
    away: "뉴캐슬",
    league: "프리미어리그",
    category: "soccer",
    status: "upcoming",
    channel: "스포츠중계 1",
  },
  {
    id: "t2",
    time: "17:30",
    home: "레버쿠젠",
    away: "라이프치히",
    league: "분데스리가",
    category: "soccer",
    status: "upcoming",
    channel: "스포츠중계 2",
  },
  {
    id: "t3",
    time: "19:00",
    home: "기아",
    away: "두산",
    league: "KBO",
    category: "baseball",
    status: "upcoming",
    channel: "스포츠중계 3",
  },
  {
    id: "t4",
    time: "20:00",
    home: "서울",
    away: "포항",
    league: "K리그1",
    category: "k-soccer",
    status: "upcoming",
    channel: "스포츠중계 4",
  },
  {
    id: "t5",
    time: "02:00",
    home: "애틀랜타",
    away: "보스턴",
    league: "NBA",
    category: "basketball",
    status: "upcoming",
    channel: "스포츠중계 5",
  },
];

export const yesterdayMatches: MatchData[] = [
  {
    id: "y1",
    time: "14:00",
    home: "리버풀",
    away: "맨체스터 유나이티드",
    homeScore: 3,
    awayScore: 1,
    league: "프리미어리그",
    category: "soccer",
    status: "finished",
    channel: "스포츠중계 1",
  },
  {
    id: "y2",
    time: "17:00",
    home: "레알 마드리드",
    away: "AT 마드리드",
    homeScore: 2,
    awayScore: 2,
    league: "라리가",
    category: "soccer",
    status: "finished",
    channel: "스포츠중계 2",
  },
  {
    id: "y3",
    time: "19:00",
    home: "NC",
    away: "롯데",
    homeScore: 7,
    awayScore: 4,
    league: "KBO",
    category: "baseball",
    status: "finished",
    channel: "스포츠중계 3",
  },
  {
    id: "y4",
    time: "02:30",
    home: "덴버",
    away: "피닉스",
    homeScore: 112,
    awayScore: 108,
    league: "NBA",
    category: "basketball",
    status: "finished",
    channel: "스포츠중계 5",
  },
];